import React, { useState } from 'react'
import PropTypes from 'prop-types'

// Constant
import { LoaderButton } from '../../LoaderButton'

// Components
import { S_NoteEditor } from './NoteEditor.styles'
import { FormField } from '../../Forms/FormField'
import { RenderIf } from '../../../components/helpers/RenderIf/RenderIf'
import { Button } from '../../Button'
import { H4 } from '../../Typography/Components/Headings/H4'

export const NoteEditor = ({
  error = '',
  flexType,
  isSaving = false,
  label,
  noteStyle = '',
  onChange = () => {},
  onSave = () => {},
  value,
}) => {
  const isBusinessNote = noteStyle === 'businessNotes'
  const isTimeLine = noteStyle === 'timeline'
  const [showField, setShowField] = useState(false)
  if (isTimeLine) {
    return (
      <S_NoteEditor className={'timeline'} flexType={flexType}>
        <RenderIf condition={!showField}>
          <Button className={'note-editor-btn'} onClick={() => setShowField(true)} text={'+ Add Note'} />
        </RenderIf>

        <RenderIf condition={showField}>
          <FormField
            className={`note-editor-field`}
            onChange={(val) => {
              onChange(val)
            }}
            placeholder={'Add new note by typing here'}
            type={'textarea'}
            value={value}
          />

          {error && <div className="error">{error}</div>}
          <LoaderButton
            className={'note-editor-btn'}
            isLoading={isSaving}
            onClick={() => {
              onSave(() => setShowField(false))
            }}
            text="Submit Note"
          />
        </RenderIf>
      </S_NoteEditor>
    )
  }

  return (
    <S_NoteEditor flexType={flexType}>
      <RenderIf condition={label}>
        <H4 mb={'15px'}>{label}</H4>
      </RenderIf>

      <FormField
        className={`note-editor-field ${isBusinessNote ? 'full-width' : 'limited-width'}`}
        onChange={(val) => {
          onChange(val)
        }}
        placeholder={'Add new note by typing here'}
        type={'textarea'}
        value={value}
      />

      {isBusinessNote && (
        <>
          {error && <div className="error">{error}</div>}
          <LoaderButton isLoading={isSaving} onClick={onSave} text="Add Note" />
        </>
      )}
    </S_NoteEditor>
  )
}

NoteEditor.propTypes = {
  error: PropTypes.string,
  flexType: PropTypes.string,
  isSaving: PropTypes.bool,
  label: PropTypes.any,
  noteStyle: PropTypes.string,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  value: PropTypes.string,
}
